import React from "react";
import { useLogUserOut } from "../hooks/auth";

const Logout = () => {
  const logout = useLogUserOut();

  React.useEffect(() => {
    if (logout) {
      logout();
      window.location = "/";
    }
  }, [logout]);
  return null;
};

export default Logout;
